import { HiringPage } from '../components/pages'

export default HiringPage
